module.exports = __webpack_public_path__ + "images/fd14fa7d379c69f903748f320fb54605-IMG_9387.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living2/IMG_9387.jpg
// module id = ./src/assets/images/slides/living2/IMG_9387.jpg
// module chunks = 0